import "./tournament-create-edit-image.scss";
import React from "react";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft, faUndoAlt } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useFormDataValidation, useImageCropper } from "../../hooks/formHooks";
import { useEffect } from "react";
import { tournamentImageEditForm } from "../../forms/TournamentForms";
import {
  selectCurrentTournament,
  setCurrentTournament,
} from "../../reducers/tournamentSlice";

const TournamentCreateEditImage = (props) => {
  const navigate = useNavigate();
  const currentTournament = useSelector(selectCurrentTournament);

  const property = "logo";

  const [context, isValid] = useFormDataValidation({
    initialValid: true,
    data: currentTournament,
    setData: setCurrentTournament,
  });

  const [
    croppedImg,
    showCroppedImage,
    saveCroppedLogo,
    applyCrop,
    undoCrop,
    croppedImgBlob,
  ] = useImageCropper(context, property);

  useEffect(() => {
    const editor = document.getElementById("image-editor");
    editor.focus();
  }, []);

  const getDrawerActions = () => {
    let actions = [
      {
        name: "Save",
        isDisabled: !isValid,
        action: saveLogo,
        type: "black",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const saveLogo = () => {
    saveCroppedLogo();
    leftNavigation();
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    return {
      title: `Edit Tournament Image`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  context.getActions = () => {
    if (!showCroppedImage) {
      return [
        { buttonTitle: "Preview", actionClick: applyCrop, type: "transparent" },
      ];
    } else {
      return [
        {
          buttonTitle: "revert",
          actionIcon: faUndoAlt,
          actionClick: undoCrop,
          type: "transparent red",
        },
      ];
    }
  };

  context.getLogo = () => {
    return currentTournament?.[property];
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle="Edit Image"
        formActions={context.getActions()}
        formSections={tournamentImageEditForm(
          context,
          showCroppedImage,
          croppedImg
        )}
      ></GSForm>
    );
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const keyPressed = () => {
    saveLogo();
  };

  return (
    <tournament-create-edit-image
      id="image-editor"
      onKeyPress={keyPressed}
      tabIndex={1}
    >
      <GSSidePanelPage
        header={getNavigation()}
        content={getContent()}
        drawer={getDrawer()}
        loading={croppedImgBlob === undefined}
        loadingText="Loading Image..."
      ></GSSidePanelPage>
    </tournament-create-edit-image>
  );
};

export default TournamentCreateEditImage;
